import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ErrorModel } from './model/error-model';
import { CommonModule } from '@angular/common';
import { BkSvgSummaryComponent } from '@shared/modules/icon-component/components/bk-svg-summary.component';
@Component({
  selector: 'app-error-page',
  imports: [CommonModule, BkSvgSummaryComponent],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.css'
})
export class ErrorPageComponent {
  @Input() public error:ErrorModel
  @Input() public gqlError:any;
  @Output() closeError=new EventEmitter<boolean>();
  close() {
    this.error=undefined;
    this.closeError.emit(true);
  }
}
